import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { statusProps, resolveStatusColor } from './status';


export default /*#__PURE__*/_defineComponent({
  __name: 'status',
  props: statusProps,
  setup(__props) {

const props = __props



const resolvedColor = computed(() => resolveStatusColor(props.color));

return { __sfc: true,props, resolvedColor }
}

})